import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ManutencaoCTEService } from 'src/app/services/gestao-de-cte/gestao-de-cte.service';
import { HttpErrorResponse } from '@angular/common/http';
import { get, uniqWith } from 'lodash';
import { GestaoDeCteComponent } from '../../gestao-de-cte.component';


@Component({
  selector: 'app-modal-peso',
  templateUrl: './modal-peso.component.html',
  styleUrls: ['./modal-peso.component.scss']
})
export class ModalPesoComponent implements OnInit {
  @Input() parent: GestaoDeCteComponent;
  @Input() dados;

  @Input() isModal = false;
  spans = {};
  gridInfo: any[];

  isLoading: boolean = false;
  isLoadingDownload: boolean = false;

  public grid: MatTableDataSource<any> = new MatTableDataSource<any>();
  public displayedColumns: string[] = [
    'nrt', 'dtRecep', 'doc', 'nFiscal', 'pesoNFiscal', 'vol', 'fonte', 'bruto', 'cubado', 'cubado_calculado', 'dtPesagem'
  ];

  paging = { index: 0, size: 10, length: 0 };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<ModalPesoComponent>,
    public snackBar: MatSnackBar,
    public route: ActivatedRoute,
    public service: ManutencaoCTEService
  ) {
    if (data) {
      this.dados = data.dados;
      this.isModal = data.isModal;
    }
  }

  ngOnInit() {
    console.log(this.dados);
    this.getPesos();
  }

  public getPesos() {
    this.isLoading = true;
    const obj = {
      identificacaoId: this.dados.id === null ? this.dados.id : this.dados.id,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    }
    this.service.getPesos(obj).subscribe(
      (response: any) => {
        this.grid.data = response.body;
        this.gridInfo = response.body;
        this.getSpans();
        response.body.length ? this.paging.length = response.body[0].totalCount : null
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(`Erro ao carregar pesos do CTE: ${this.dados.id}, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      }).add(() => this.isLoading = false);
  }

  getSpans() {
    this.spans = Object.assign({}, {
      nrt: this.spanDeep(['nrt'], this.gridInfo),
      dtRecep: this.spanDeep(['nrt', 'dtRecep'], this.gridInfo),
      doc: this.spanDeep(['nrt', 'dtRecep', 'doc'], this.gridInfo),
      nFiscal: this.spanDeep(['nrt', 'dtRecep', 'doc', 'nFiscal'], this.gridInfo),
      pesoNFiscal: this.spanDeep(['nrt', 'dtRecep', 'doc', 'nFiscal', 'pesoNFiscal'], this.gridInfo),
      vol: this.spanDeep(['nrt', 'dtRecep', 'doc', 'nFiscal', 'pesoNFiscal', 'vol'], this.gridInfo),
    });
  }

  spanDeep(paths: string[] | null, data: any[]) {
    if (!paths.length) {
      return [...data]
        .fill(0)
        .fill(data.length, 0, 1);
    }
    const copyPaths = [...paths];
    const path = copyPaths.shift();
    const uniq = uniqWith(data, (a, b) => get(a, path) === get(b, path))
      .map(item => get(item, path));
    return uniq
      .map(uniqItem => this.spanDeep(copyPaths, data.filter(item => uniqItem === get(item, path))))
      .flat(paths.length);
  }

  getRowSpan(path, idx) {
    return this.spans[path][idx];
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.getPesos();
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    const obj = {
      identificacaoId: this.dados.id === null ? this.dados.id : this.dados.id,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    }
    this.service.getPesosExcel(obj).subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
